import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { section: String }

  connect() {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    this.seen = false
    this.observer = new IntersectionObserver(entries => {
      if (this.seen || !entries.some(entry => entry.isIntersecting)) return
      this.seen = true
      window.posthog?.capture('www.section_viewed', { section: this.sectionValue })
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
